<template>
  <div class="f-h f-w">
    <Stats select-mgt-teams />
  </div>
</template>

<script>
/**
 * Management page for teams stats.
 */

// Components
import Stats from '@/views/dmp/stats.vue';

export default {

  name: 'MgtStats',

  components: {
    Stats,
  },

  data() {
    return {
      pageTitle: this.$t('message.STATS_FROM_MGT'),
    };
  },
};
</script>
